import React from 'react'
// styles are all global
import styles from './TimePickerInput.scss' // eslint-disable-line
import moment from 'moment'
import Timepicker from 'rc-time-picker'
import 'rc-time-picker/assets/index.css'

export class TimePickerInput extends React.PureComponent {
  static defaultProps = {
    showSecond: false,
    inputReadOnly: true,
    use12Hour: true
  }

  constructor (props) {
    super(props)

    this.state = {
      time: props.time || props.allowBlank ? null : moment()
    }
  }

  formatTime = (time) => {
    const { allowBlank } = this.props
    if (!time) {
      return allowBlank ? '' : moment().format('h:MM A')
    } else {
      return moment(time).format('h:mm A')
    }
  }

  render () {
    const { time } = this.state

    return (
      <Timepicker
        defaultValue={time}
        format='h:mm A'
        inputReadOnly
        {...this.props}
      />
    )
  }
}
